import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

const SCROLL_WIDTH = 14;

export default function I() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');

    useEffect(() => {
        let pageW = window.innerWidth - SCROLL_WIDTH;
        pageW = pageW > 2560 ? 2560 : pageW;

        AniContainer.create({
            asyncFromTo: [['.d2x-detail-I .video-box', { y: -(pageW * 0.07769) }, { y: 0 }, 1]],
            asyncTimeLine: [0],
            triggerElement: '.d2x-detail-I .video-box',
            triggerHook: 1,
            offset: 0,
            duration: '184%',
        });
    }, []);

    return (
        <div
            className={`d2x-detail-I ${css.d2xDetailI} GtmModuleData-section`}
            id="d2x-detail-I"
            data-section-id={'d2x-detail-I'}
            data-section-title={t('sec9_title')}
        >
            <div className="white-box">
                <div className="text-box">
                    <div className="slogan">{t('sec9_slogan')}</div>
                    <div className="title">{t('sec9_title')}</div>
                    <div className="desc">
                        {t.rich('sec9_desc', {
                            line: (text: any) => <span className="green">{text}</span>,
                        })}
                    </div>
                </div>
            </div>
            <div className="ani-box">
                <div className="video-box">
                    <div className="video">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z9.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/z9.jpg')}
                            alt={t('sec9_title')}
                            aria-label={t('sec9_title')}
                        />
                    </div>
                </div>
            </div>
            <div className="white-point">
                <div className="desc2">{t('sec9_desc2')}</div>
            </div>
        </div>
    );
}
